module.exports = __webpack_public_path__ + "05_mid_brown.da831dfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/05_mid_brown.png
// module id = x575
// module chunks = 0